import {platformView} from "../Helpers/platformView";

export const showVolumeUpButton = () => {
	const volumeDownButton = document.querySelector(platformView()? "#volume-down-mobile" : "#volume-down-desktop") as HTMLElement;
	const volumeUpButton = document.querySelector(platformView()? "#volume-up-mobile" : "#volume-up-desktop") as HTMLElement;
	const videoEl = document.querySelector(platformView() ? '#welcome-video-mobile' : '#welcome-video-desktop') as HTMLVideoElement;


	if (volumeUpButton.classList.contains("hidden")) {
		volumeUpButton.classList.remove("hidden");
		// hide volume down
		volumeDownButton.classList.add("hidden");
		// play sound
		videoEl.muted = false;
	} else {
		volumeUpButton.classList.add("hidden");
		volumeDownButton.classList.remove("hidden");
		videoEl.muted = true;
	}
}
